import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthSuccess = () => {

  const navigate = useNavigate();

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      navigate("/");
      return;
    }

    /* SAVE TOKEN */
    localStorage.setItem("token", token);
    sessionStorage.setItem("token", token);

    /* LOGIN SUCCESS FLAG */
    sessionStorage.setItem("loginSuccess", "true");

    /* ================= JOIN TRIP AFTER LOGIN ================= */

    const pendingJoin = localStorage.getItem("pendingTripJoin");

    if (pendingJoin) {

      localStorage.removeItem("pendingTripJoin");

      navigate(`/join/${pendingJoin}`);

      return;

    }

    /* ================= NORMAL REDIRECT ================= */

    const redirect = localStorage.getItem("redirectAfterLogin");

    if (redirect) {

      localStorage.removeItem("redirectAfterLogin");

      window.location.replace(redirect);

    } else {

      navigate("/");

    }

  }, [navigate]);

  return (
    <p style={{ textAlign: "center" }}>
      Logging you in…
    </p>
  );

};

export default AuthSuccess;